import { Link } from "react-router-dom";

const TODAY = new Date().toLocaleDateString("en-AU", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

const SECTIONS = [
  {
    h: "Overview",
    p: [
      "RegenX Wellness (\"we\", \"us\", \"our\") respects your privacy. This policy explains what personal information we collect, how we use it, and the choices you have. It applies to information collected through our website and ordering process.",
    ],
  },
  {
    h: "Information we collect",
    p: [
      "Account information: when you create an account we collect your full name, email address, and a hashed password.",
      "Order information: when you place an order we collect your shipping address, phone number (optional), and the items purchased. Payment card details are processed directly by Stripe — we do not store full card numbers on our servers.",
      "Usage information: standard server logs (IP address, browser type, pages viewed) are retained for security and analytics purposes.",
    ],
  },
  {
    h: "How we use your information",
    p: [
      "To process and ship your orders, communicate about your purchases, prevent fraud, and meet our legal obligations.",
      "To send transactional emails (order confirmation, shipping updates). We do not send marketing emails unless you have opted in to our newsletter.",
    ],
  },
  {
    h: "Sharing your information",
    p: [
      "We share information with service providers strictly to operate our business: Stripe (payment processing), our shipping carrier, and our email delivery provider. We do not sell your personal information.",
      "We may disclose information where required by law or to protect the rights, property, or safety of RegenX Wellness, our customers, or others.",
    ],
  },
  {
    h: "Cookies & local storage",
    p: [
      "We use browser local storage to remember your cart, your authentication token, and your age-verification acceptance. We use cookies sparingly for session management. You can clear these at any time via your browser settings.",
    ],
  },
  {
    h: "Data retention",
    p: [
      "Account and order records are retained for as long as your account is active plus a period of up to seven years to comply with Australian tax and consumer-law obligations. You may request deletion of your account at any time, subject to those legal retention requirements.",
    ],
  },
  {
    h: "Your rights",
    p: [
      "You have the right to access, correct, or request deletion of the personal information we hold about you. To exercise these rights, contact us at info@regenxwellness.com.au.",
    ],
  },
  {
    h: "Security",
    p: [
      "We use industry-standard measures including encrypted transport (HTTPS), hashed passwords, and limited internal access to protect your information. No system is perfectly secure; if you believe your account has been compromised, contact us immediately.",
    ],
  },
  {
    h: "Changes to this policy",
    p: [
      "We may update this policy from time to time. Material changes will be posted on this page with an updated \"last updated\" date.",
    ],
  },
  {
    h: "Contact",
    p: [
      "Questions about this privacy policy can be directed to info@regenxwellness.com.au.",
    ],
  },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="animate-in fade-in duration-500">
      <section className="px-6 md:px-12 lg:px-24 pt-20 pb-12 border-b border-border max-w-4xl">
        <p className="overline text-primary mb-5">Legal</p>
        <h1 className="editorial-heading text-5xl md:text-6xl text-secondary leading-[0.95] mb-6">
          Privacy policy
        </h1>
        <p className="text-sm text-muted-foreground">Last updated: {TODAY}</p>
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-16 max-w-4xl space-y-12">
        {SECTIONS.map((s, i) => (
          <div key={i} data-testid={`privacy-section-${i}`}>
            <h2 className="editorial-heading text-2xl md:text-3xl text-secondary mb-4">
              {s.h}
            </h2>
            {s.p.map((para, j) => (
              <p key={j} className="text-base text-muted-foreground leading-relaxed mb-4">
                {para}
              </p>
            ))}
          </div>
        ))}
        <div className="pt-8 border-t border-border">
          <Link
            to="/"
            className="text-xs uppercase tracking-[0.22em] text-secondary hover:text-primary border-b border-secondary pb-1"
            data-testid="privacy-back-home"
          >
            ← Back home
          </Link>
        </div>
      </section>
    </div>
  );
}
